import { apiClient } from '@/services/api/axiosClient';
import { endpoints } from '@/services/api/apiEndpoints';
import type { AuthTokens, User, Organization } from '@/types/user.types';

// Thin wrapper over the auth endpoints. Kept as plain async functions
// (not React Query hooks) because auth needs to be called imperatively
// from the Zustand store and from the Axios interceptor, both outside
// of React's render cycle.
export const authService = {
  async login(username: string, password: string): Promise<{ user: User; tokens: AuthTokens; current_organization: Organization | null; is_platform_admin: boolean }> {
    const { data } = await apiClient.post(endpoints.auth.login, { email: username, password });
    return data;
  },
  async refresh(refreshToken: string): Promise<AuthTokens> {
    const { data } = await apiClient.post(endpoints.auth.refresh, { refreshToken });
    return data;
  },
  async logout(): Promise<void> {
    await apiClient.post(endpoints.auth.logout);
  },
  async fetchCurrentUser(): Promise<{ user: User; current_organization: Organization | null; is_platform_admin: boolean }> {
    const { data } = await apiClient.get(endpoints.auth.me);
    return data;
  },
};
